import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AfTranslateDirective } from '@shared/modules/translate/directive/af-translate.directive';
import { NgClass } from '@angular/common';
import { CustomLandingFactory } from '@shared/factories/custom-landing/custom-landing.factory';
import { ModalServiceService } from '@shared/services/modal-service/modal-service.service';

@Component({
    selector: 'advice-modal',
    templateUrl: './advice-modal.component.html',
    standalone: true,
    imports: [
      NgClass,
      AfTranslateDirective
    ]
})

export class AdviceModalComponent implements OnInit {
  constructor( private dialogRef: DynamicDialogRef<AdviceModalComponent>,
    private dialogConfig: DynamicDialogConfig,
    private customLanding: CustomLandingFactory,
    private modalService: ModalServiceService) { }

  isLanding: Boolean = this.customLanding.isLanding();
  configuration: any = this.dialogConfig.data;
    // {
    //   text: texto principal,
    //   titleText: cabecera texto
    //   typeModal: 'rich' | 'simple'(sin definir) ,
    //   type: typeModal (alert | info | success | warning),
    //   specificIcon?: specific,
    //   typeButtons: botones a mostrar
    //   list: list,
    //   typeList: ''
    // }
  adviceModal:any ={
    classHeader: 'common-status-message__ji-container-info',
    iconHeader: 'lf-icon-info-full',
    typeText: 'normal',
    firstQuestionText: '',
    buttonLink: '',
    lastQuestionText: '',
    // errorTranslate: '',
  }

  ngOnInit(): void {
    this.configureModal();
    this.configureHeader();
  }

  configureModal(){
    // this.adviceModal.errorTranslate = this.translate.instant('users-admin.import.error-'+this.from);
    if(this.configuration.typeLink === 'errorLink'){
      this.adviceModal.typeText = 'link';
      this.adviceModal.firstQuestionText = this.configuration.text[0];
      this.adviceModal.buttonLink = this.configuration.text[1];
      this.adviceModal.fromInfo = this.configuration.typeButtons;
    }
  }

  configureHeader(){
    let headerClass: string = this.configuration.typeModal === 'rich'?'common-status-message__jt-container-':'common-status-message__ji-container-';
    let type: string = this.configuration.type;
    if(this.configuration.specificIcon){
      this.adviceModal.iconHeader = this.configuration.specificIcon;
    }else{
      switch(this.configuration.type){
        case 'success':
          this.adviceModal.iconHeader = 'lf-icon-check-round-full';
          break;
        case 'warning':
          this.adviceModal.iconHeader = 'lf-icon-warning-full';
          break;
        case 'error':
          this.adviceModal.iconHeader = 'lf-icon-close-round-full';
          type = 'alert';
          break;
        case 'alert':
          this.adviceModal.iconHeader = 'lf-icon-alert-full';
          break;
        default:
        // case 'info':
          this.adviceModal.iconHeader = 'lf-icon-info-full';
          break;
      }
    }
    this.adviceModal.classHeader = headerClass + type;
  }

  openInfoModal(){
    let configuration: any = {
      fromInfo: this.adviceModal.fromInfo
    };
    this.modalService.modalMoreInfo(configuration);
  }

  handleAccept(optionSelect: string = 'ok') {
    this.dialogRef.close({result: optionSelect})
  }

  handleDismiss() {
    this.dialogRef.close({result:'cancel'});
  }

}
